// Module
var code = `<modal on-api-ready="\$ctrl.onMembersModalReady">
  <modal-header>
    <h2>Group members of {{\$ctrl.selectedGroup.groupName}}</h2>
  </modal-header>
  <modal-body>
    <div class="labelled-field labelled-field--long">
      <label for="group-member-sort" class="add-on">Sort by</label>
      <select
        id="group-member-sort"
        ng-model="\$ctrl.sortBy"
        ng-options="s.value as s.label for s in \$ctrl.groupMembersSortByOptions"
        ng-change="\$ctrl.tableConfig = \$ctrl.prepareGroupMembersTable({group: \$ctrl.selectedGroup})"
        ng-required="true">
      </select>
    </div>
    <table ng-table="\$ctrl.tableConfig" class="table">
      <thead>
      <tr>
        <th>No.</th>
        <th>Product number</th>
        <th>Customer name</th>
        <th>Customer address</th>
        <th>Product name</th>
        <th>Principal amount</th>
        <th>Principal balance</th>
        <th>Earliest due date</th>
        <th>Latest due date</th>
        <th>CBU charge balance</th>
        <th>Due amount</th>
        <th>Overdue amount</th>
        <th>Outstanding amount</th>
        <th>Status</th>
        <th>For payment</th>
        <th>Payment amount</th>
        <th>
          <span ng-if="\$ctrl.collectionsReceiptType === 'TEMPORARY'">TI#</span>
          <span ng-if="\$ctrl.collectionsReceiptType === 'OFFICIAL'">IN#</span>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr ng-repeat="item in \$data" ng-if="\$data">
        <td>{{ \$ctrl.getRowNo(\$index, \$ctrl.tableConfig) }}</td>
        <td>{{ item.productNumber }}</td>
        <td>{{ item.customerName }}</td>
        <td>{{ item.customerAddress }}</td>
        <td>{{ item.productName }}</td>
        <td>{{ item.principalAmount | nxCurrency }}</td>
        <td>{{ item.principalBalance | nxCurrency }}</td>
        <td>{{ item.earliestDueDate | prettyDate }}</td>
        <td>{{ item.latestDueDate | prettyDate }}</td>
        <td>{{ item.cbuChargeBalance | nxCurrency }}</td>
        <td>{{ item.dueAmount | nxCurrency }}</td>
        <td>{{ item.overdueAmount | nxCurrency }}</td>
        <td>{{ item.outstandingAmount | nxCurrency }}</td>
        <td>{{ item.status | prettyEnum }}</td>
        <td>
          <input
            type="checkbox"
            ng-model="\$ctrl.getPayment({productId: item.productId}).selected"
            ng-click="\$ctrl.toggleForPayment({collection: item})"/>
        </td>
        <td class="td--small-min-width">
          <cash
            ng-disabled="!\$ctrl.getPayment({productId: item.productId})"
            ng-required="!!\$ctrl.getPayment({productId: item.productId})"
            ng-model="\$ctrl.getPayment({productId: item.productId}).amount"></cash>
        </td>
        <td class="td--small-min-width">
          <span ng-if="\$ctrl.collectionsReceiptType === 'TEMPORARY'">
            <input
              class="dashboard-collections__collections-tr-input"
              type="text"
              ng-model="\$ctrl.getPayment({productId: item.productId}).temporaryReceipt"
              ng-disabled="!\$ctrl.getPayment({productId: item.productId})"
              ng-required="!!\$ctrl.getPayment({productId: item.productId}) && \$ctrl.collectionModuleReceiptRequired"/>
          </span>
          <span ng-if="\$ctrl.collectionsReceiptType === 'OFFICIAL'">
            <input
              class="dashboard-collections__collections-tr-input"
              type="text"
              ng-model="\$ctrl.getPayment({productId: item.productId}).officialReceipt"
              ng-disabled="!\$ctrl.getPayment({productId item.productId}) || \$ctrl.automatedOfficialReceiptEnabled"
              ng-required="!!\$ctrl.getPayment({productId: item.productId}) && \$ctrl.collectionModuleReceiptRequired"/>
          </span>
        </td>
      </tr>

      <tr>
        <td>Total:</td>
        <td colspan="4"></td>
        <td>{{\$ctrl.selectedGroup.totalPrincipalAmount | nxCurrency}}</td>
        <td>{{\$ctrl.selectedGroup.totalPrincipalBalance | nxCurrency}}</td>
        <td colspan="3"></td>
        <td>{{\$ctrl.selectedGroup.totalDueAmount | nxCurrency}}</td>
        <td>{{\$ctrl.selectedGroup.totalOverdueAmount | nxCurrency}}</td>
        <td>{{(\$ctrl.selectedGroup.totalOutstandingAmount) | nxCurrency}}</td>
        <td></td>
        <td>
          <input
            type="checkbox"
            ng-model="\$ctrl.selectedPageForPayment"
            ng-click="\$ctrl.togglePageForPayment({collectionPage: \$data})"/>
        </td>
        <td>
          <cash value="\$ctrl.getPaymentsTotalAmount({})" ng-disabled="true"></cash>
        </td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </modal-body>
  <modal-footer>
    <div ng-if="\$ctrl.valueDateEnabled" class="labelled-field">
      <label>Value Date</label>
      <value-date ng-model="\$ctrl.valueDate"></value-date>
    </div>
    <button class="btn" data-dismiss="modal" ng-click="\$ctrl.closeModal()">Close</button>
    <button class="btn btn-warning" ng-disabled="\$ctrl.getPayments({}).length === 0" ng-click="\$ctrl.clearPayments({})">Clear all</button>
    <button class="btn btn-success" ng-disabled="!\$ctrl.isValidPayments({})" ng-click="\$ctrl.submitPayment()">Confirm payment</button>
  </modal-footer>
</modal>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/collections/payment/members-modal/collections-payment-members-modal.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;